module.exports = {
    login: '/login',
    logout: '/logout',
    admin: '/admin',
    stocks: '/stocks',
    root: '/',
    priceChecker: '/pricechecker',
    picking: '/picking',
    stocktake: '/stocktake',
};
